<template>
  <div class="tile is-ancestor footer-padding">
    <div class="tile is-parent is-vertical is-12">
      <Tile title="General Experience"
        subtitle="Fill in your experience details">
        <div class="columns">
          <b-field class="column" label="General experience (in years)"
            v-if="isLoggedInOfTypes(['charterer'])">
            <b-input type="number" :value="edittedProfile.experience_years"
              @input="v=> edittedProfile.experience_years=(v||null)"/>
          </b-field>
          <b-field class="column" label="Yachting experience (in years)"
            v-if="isLoggedInOfTypes(['crew'])">
            <b-input type="number" :value="edittedProfile.yachting_experience_years"
              @input="v=> edittedProfile.yachting_experience_years=(v||null)"/>
          </b-field>
          <b-field class="column" label="Chef experience (in years)"
            v-if="isLoggedInOfTypes(['crew'])">
            <b-input type="number" :value="edittedProfile.chef_experience_years"
              @input="v=> edittedProfile.chef_experience_years=(v||null)"/>
          </b-field>
          <b-field class="column" label="Diving experience (in years)"
            v-if="isLoggedInOfTypes(['diver'])">
            <b-input type="number" :value="edittedProfile.diving_experience_years"
              @input="v=> edittedProfile.diving_experience_years=(v||null)"/>
          </b-field>
          <b-field class="column" label="Dock services experience (in years)"
            v-if="isLoggedInOfTypes(['on_dock'])">
            <b-input type="number" :value="edittedProfile.on_dock_experience_years"
              @input="v=> edittedProfile.on_dock_experience_years=(v||null)"/>
          </b-field>
          <div class="column" v-if="isLoggedInOfTypes(['on_dock', 'diver', 'crew'])">
            <span class="label">CV (in pdf form)</span>
            <b-upload @input="(f) => tempCV = f">
              <a class="button is-primary">
                <b-icon icon="upload"></b-icon>
                <span>Click to upload</span>
              </a>
            </b-upload>
            <span v-if="tempCV" class="label">New file {{tempCV.name}}</span>
            <div><a v-if="profile.cv" :href="profile.cv.file" target="_blank">
              See your existing CV
            </a></div>

          </div>

        </div>
      </Tile>

      <Tile title="Detailed Experience"
        subtitle="Fill your experience per field"
        v-if="isLoggedInOfTypes(['crew'])">
        <div class="columns">
          <div class="column">
            <LevelSelect
              :value="edittedProfile.experience_items.find(ie => ie.name === e)"
              :valueGetter="(v) => v ? v.level: 0"
              @input="(v) => editExperienceItem(e, v)"
              v-for="e in experienceItems0"
              includeZero
              :key="e" :label="e" />
          </div>
          <div class="column">
            <LevelSelect
              :value="edittedProfile.experience_items.find(ie => ie.name === e)"
              :valueGetter="(v) => v ? v.level: 0"
              @input="(v) => editExperienceItem(e, v)"
              v-for="e in experienceItems1"
              includeZero
              :key="e" :label="e" />
          </div>
        </div>
      </Tile>
    </div>

    <div class="tile is-parent is-vertical is-6">
    </div>
    <Footer>
      <a :class="[
        'button', 'is-medium',
        'is-primary', loading && 'is-loading']"
        :disabled="!hasChanges"
        @click="save">
        Save
      </a>
    </Footer>
  </div>
</template>

<script>
import Tile from '@/components/Tile';
import Footer from '@/components/Footer';
import LevelSelect from '@/components/LevelSelect';
import { mapState, mapActions, mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';

export default {
  data() {
    return {
      loading: false,
      tempCV: null,
      edittedProfile: null,
    };
  },
  components: {
    Tile,
    Footer,
    LevelSelect,
  },
  computed: {
    hasChanges() {
      return this.tempCV
        || this.profile.chef_experience_years !== this.edittedProfile.chef_experience_years
        || this.profile.yachting_experience_years !== this.edittedProfile.yachting_experience_years
        || this.profile.diving_experience_years !== this.edittedProfile.diving_experience_years
        || this.profile.on_dock_experience_years !== this.edittedProfile.on_dock_experience_years
        || this.profile.experience_years !== this.edittedProfile.experience_years
        || !isEqual(this.profile.experience_items, this.edittedProfile.experience_items);
    },
    ...mapState({
      experienceItems: state => state.content.experience_items,
      profile: state => state.auth.user.profile,
    }),
    ...mapGetters({
      isLoggedInOfTypes: 'auth/isLoggedInOfTypes',
    }),
    experienceItems0() {
      return this.experienceItems.filter((_, i) => i % 2 === 0);
    },
    experienceItems1() {
      return this.experienceItems.filter((_, i) => i % 2 === 1);
    },
  },
  methods: {
    ...mapActions({
      updateProfile: 'auth/updateProfile',
    }),

    editExperienceItem(name, level) {
      const index = this.edittedProfile.experience_items.findIndex(ie => ie.name === name);

      if (index !== -1 && level) {
        this.edittedProfile.experience_items = this.edittedProfile.experience_items.map((e, i) => {
          if (i === index) {
            return { ...e, level };
          }
          return e;
        });
        return;
      }
      if (index === -1 && level) {
        this.edittedProfile.experience_items.push({ name, level });
        return;
      }
      if (index !== -1 && !level) {
        this.edittedProfile.experience_items.splice(index, 1);
      }
    },
    async saveCV() {
      const data = new FormData();
      data.append('category', 'cv');
      data.append('file', this.tempCV);
      const resp = await this.$http.post('files/', data, { 'Content-Type': 'multipart/form-data' });
      this.edittedProfile.cv = resp.data.id;
    },
    async save() {
      this.loading = true;
      if (this.tempCV) {
        try {
          await this.saveCV();
        } catch (e) {
          this.$toast.open({
            message: 'Could not save the new cv',
            type: 'is-danger',
          });
          this.tempCV = null;
          this.loading = false;
          return;
        }
      }

      try {
        await this.updateProfile(this.edittedProfile);
      } catch (e) {
        this.$toast.open({
          message: 'Could not save the personal info',
          type: 'is-danger',
        });
        return;
      } finally {
        this.loading = false;
      }
      this.initialize();
    },
    initialize() {
      this.edittedProfile = {
        id: this.profile.id,
        experience_items: cloneDeep(this.profile.experience_items),
        chef_experience_years: this.profile.chef_experience_years,
        yachting_experience_years: this.profile.yachting_experience_years,
        diving_experience_years: this.profile.diving_experience_years,
        on_dock_experience_years: this.profile.on_dock_experience_years,
        experience_years: this.profile.experience_years,
      };
    },
  },
  created() {
    this.initialize();
  },
};
</script>

<style lang="scss" scoped>
</style>
